export function lockBodyScroll() {
  try {
    if (typeof document === "undefined") return () => {};
    if (typeof window === "undefined") return () => {};

    const bodyElement = document.body;
    const htmlElement = document.documentElement;
    if (!bodyElement || !htmlElement) return () => {};

    const dataset = bodyElement.dataset || {};
    const currentCountRaw = dataset.flareScrollLockCount;
    const currentCount = Number.parseInt(currentCountRaw || "0", 10) || 0;

    if (currentCount === 0) {
      const scrollTopPosition =
        typeof window.scrollY === "number" ? window.scrollY : 0;

      dataset.flareScrollLockScrollTop = String(scrollTopPosition);

      // Preserve styles so we can restore exactly.
      dataset.flareScrollLockPreviousBodyOverflow = bodyElement.style.overflow || "";
      dataset.flareScrollLockPreviousBodyPosition = bodyElement.style.position || "";
      dataset.flareScrollLockPreviousBodyTop = bodyElement.style.top || "";
      dataset.flareScrollLockPreviousBodyLeft = bodyElement.style.left || "";
      dataset.flareScrollLockPreviousBodyRight = bodyElement.style.right || "";
      dataset.flareScrollLockPreviousBodyWidth = bodyElement.style.width || "";

      dataset.flareScrollLockPreviousHtmlOverflowY = htmlElement.style.overflowY || "";
      dataset.flareScrollLockPreviousHtmlOverflowX = htmlElement.style.overflowX || "";

      // Keep the scrollbar gutter visible (prevents layout shift), but freeze the page.
      // - Force scrollbar on html
      // - Fix body in place at current scroll offset
      htmlElement.style.overflowY = "scroll";
      bodyElement.style.position = "fixed";
      bodyElement.style.top = `-${scrollTopPosition}px`;
      bodyElement.style.left = "0";
      bodyElement.style.right = "0";
      bodyElement.style.width = "100%";
      bodyElement.style.overflow = "hidden";
    }

    dataset.flareScrollLockCount = String(currentCount + 1);

    return () => {
      try {
        if (typeof document === "undefined") return;
        const bodyToUnlock = document.body;
        const htmlToUnlock = document.documentElement;
        if (!bodyToUnlock || !htmlToUnlock) return;

        const unlockDataset = bodyToUnlock.dataset || {};
        const activeCount = Number.parseInt(
          unlockDataset.flareScrollLockCount || "0",
          10,
        );
        const nextCount = Math.max(0, (Number.isFinite(activeCount) ? activeCount : 0) - 1);

        if (nextCount === 0) {
          const scrollTopRaw = unlockDataset.flareScrollLockScrollTop;
          const scrollTopPosition = Number.parseInt(scrollTopRaw || "0", 10) || 0;

          // To avoid visual flash: remove fixed positioning and restore scroll
          // in the same frame. We pre-set scrollY via scrollTo before browser paints.

          // Temporarily disable smooth scrolling to ensure instant restoration
          const prevScrollBehavior = htmlToUnlock.style.scrollBehavior;
          htmlToUnlock.style.scrollBehavior = 'auto';

          // Remove fixed positioning from body
          bodyToUnlock.style.overflow =
            unlockDataset.flareScrollLockPreviousBodyOverflow || "";
          bodyToUnlock.style.position =
            unlockDataset.flareScrollLockPreviousBodyPosition || "";
          bodyToUnlock.style.top =
            unlockDataset.flareScrollLockPreviousBodyTop || "";
          bodyToUnlock.style.left =
            unlockDataset.flareScrollLockPreviousBodyLeft || "";
          bodyToUnlock.style.right =
            unlockDataset.flareScrollLockPreviousBodyRight || "";
          bodyToUnlock.style.width =
            unlockDataset.flareScrollLockPreviousBodyWidth || "";

          // Restore html overflow
          htmlToUnlock.style.overflowY =
            unlockDataset.flareScrollLockPreviousHtmlOverflowY || "";
          htmlToUnlock.style.overflowX =
            unlockDataset.flareScrollLockPreviousHtmlOverflowX || "";

          // Restore scroll position using both methods for reliability
          htmlToUnlock.scrollTop = scrollTopPosition;
          window.scrollTo(0, scrollTopPosition);

          // Restore scroll behavior
          htmlToUnlock.style.scrollBehavior = prevScrollBehavior;

          delete unlockDataset.flareScrollLockScrollTop;
          delete unlockDataset.flareScrollLockPreviousBodyOverflow;
          delete unlockDataset.flareScrollLockPreviousBodyPosition;
          delete unlockDataset.flareScrollLockPreviousBodyTop;
          delete unlockDataset.flareScrollLockPreviousBodyLeft;
          delete unlockDataset.flareScrollLockPreviousBodyRight;
          delete unlockDataset.flareScrollLockPreviousBodyWidth;
          delete unlockDataset.flareScrollLockPreviousHtmlOverflowY;
          delete unlockDataset.flareScrollLockPreviousHtmlOverflowX;
          delete unlockDataset.flareScrollLockCount;
        } else {
          unlockDataset.flareScrollLockCount = String(nextCount);
        }
      } catch {
        // ignore
      }
    };
  } catch {
    return () => {};
  }
}


